export enum LiveClassStatusType {
  SIGNUP_CONFIRM = 'SIGNUP_CONFIRM',
  SIGNUP_LESSON_SELECTION = 'SIGNUP_LESSON_SELECTION',
  LOCKED = 'LOCKED',
  SIGNED_UP = 'SIGNED_UP',
  READY = 'READY',
  JOINED = 'JOINED',
  COMPLETE = 'COMPLETE',
}
